
import { useCallback, useEffect, useState } from "react";
import { AlphaValues, BetaValues, DeepDiveType } from "types";
import "./handles.scss";
import moment, { Moment } from "moment";
import api from "api";

function Handles({
  selectedDate,
  breakDownPeriod,
  clientId,
  projectId,
  streamIds,
  rail,
  dateTo,
  dateFrom,
  vals,
}: {
  selectedDate: Date;
  breakDownPeriod: string;
  clientId: number;
  projectId: number;
  streamIds: number[];
  rail: any;
  dateTo: Moment;
  dateFrom: Moment;
  vals: any[];
}) {
  const [alphaValue, setAlphaValue] = useState<AlphaValues[]>([]);
  const [betaValue, setBetaValue] = useState<BetaValues[]>([]);
  const [breakDownData, setBreakDownData] = useState<DeepDiveType[]>([]);
  var week: any = "";



  const getDiveData = useCallback(() => {
    api.deepDiveBreakdown
      .getOwned(projectId!, dateFrom!, dateTo!, rail!, streamIds!)
      .then((data) => {
        setBreakDownData(data);
      })
      .catch((err) => {
        alert("No data found for deep-dive");
      });
  }, [dateFrom, rail, streamIds, dateTo, projectId]);

  useEffect(() => {
    getDiveData();
  }, [dateTo, breakDownPeriod, rail, streamIds, dateFrom, getDiveData]);


  var daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getAlphaValues = useCallback(() => {
    var d = new Date(selectedDate);
    switch (breakDownPeriod) {
      case "Hourly":
        var startDate = new Date(d).setHours(new Date(d).getHours() - 12, 0, 0);
        var alphaValues: any = [];
        for (
          var i = new Date(startDate);
          i < new Date(d.setHours(new Date(d).getHours(), 0, 0));
          i.setHours(i.getHours() + 1)
        ) {
          alphaValues.push(daysOfWeek[i.getDay()]);
        }
        setAlphaValue(alphaValues);
        return alphaValues;
      case "Daily":
        var startDate = new Date(new Date(d).setDate(d.getDate() - 7)).setHours(
          0,
          0,
          0,
          0
        );
        alphaValues = [];
        for (
          var i = new Date(startDate);
          i < new Date(d);
          i.setDate(i.getDate() + 1)
        ) {
          alphaValues.push(AddSuffix(i.getDate()));
        }
        setAlphaValue(alphaValues);
        return alphaValues;
      case "Weekly":
        var startDate = new Date(d).setDate(new Date(d).getDate() - 7 * 5);
        var alphaValues: any = [];
        for (
          var i = new Date(startDate);
          i <= new Date(d);
          i.setDate(i.getDate() + 7)
        ) {
          alphaValues.push(months[i.getMonth()]);
        }
        setAlphaValue(alphaValues);
        return alphaValues;
    }
  }, [breakDownPeriod, selectedDate]);

  useEffect(() => {
    getAlphaValues();
  }, [breakDownPeriod, selectedDate]);

  function GetWeek(i: any) {
    var a: any = i;
    var b: any = new Date(a.getFullYear(), 0, 1);
    return (week = Math.ceil(((a - b) / 86400000 + b.getDay() + 1) / 7));
  }

  const getBetaValues = useCallback(() => {
    var d = new Date(selectedDate);
    switch (breakDownPeriod) {
      case "Hourly":
        var startDate = new Date(d).setHours(new Date(d).getHours() - 12, 0, 0);
        var betaValues: any = [];
        for (
          var i = new Date(startDate);
          i < new Date(d.setHours(new Date(d).getHours(), 0, 0));
          i.setHours(i.getHours() + 1)
        ) {
          var hour = i.getHours();
          var hourString = hour < 10 ? "0" + hour : hour;
          betaValues.push(hourString + ":00");
        }
        setBetaValue(betaValues);
        return betaValues;
      case "Daily":
        var startDate = new Date(new Date(d).setDate(d.getDate() - 7)).setHours(
          0,
          0,
          0,
          0
        );
        var betaValues: any = [];
        for (
          var i = new Date(startDate);
          i < new Date(d);
          i.setDate(i.getDate() + 1)
        ) {
          betaValues.push(daysOfWeek[i.getDay()]);
        }
        setBetaValue(betaValues);
        return betaValues;
      case "Weekly":
        var startDate = new Date(d).setDate(new Date(d).getDate() - 7 * 5);
        var betaValues: any = [];
        for (
          var i = new Date(startDate);
          i <= new Date(d);
          i.setDate(i.getDate() + 7)
        ) {
          GetWeek(i);
          betaValues.push("Week " + week);
        }
        setBetaValue(betaValues);
        return betaValues;
    }
  }, [breakDownPeriod, selectedDate]);

  function GetRowData(data: any, val: number, j: number) {
    var d = new Date(selectedDate);

    switch (breakDownPeriod) {
      case "Hourly":
        var date: any = new Date(d).setHours(
          new Date(d).getHours() - (12 - j),
          0,
          0,
          0
        );
        date = moment(date).format("dd MMM yyyy HH");
        return data.filter(
          (x: any) =>
            x.Value === val && (x.DatePosted, "dd MMM yyyy HH") === date
        );
      case "Daily":
        var date: any = new Date(d).setDate(new Date(d).getDate() - (7 - j));
        date = moment(date).format("dd MMM yyyy");
        if (data.status !== 204) {
          return data.filter(
            (x: any) =>
              x.Value === val &&
              moment(x.DatePosted).format("dd MMM yyyy") === date
          );
        }
        else {
          return <></>
        }
      case "Weekly":
        var newDate = new Date(
          new Date(d).setDate(new Date(d).getDate() - 7 * (5 - j))
        );
        newDate = new Date(
          newDate.setDate(newDate.getDate() - newDate.getDay())
        );
        var dateTo = new Date(newDate);
        dateTo = new Date(
          new Date(dateTo.setDate(new Date(newDate).getDate() + 7))
        );
        if (data.status !== 204) {

          return data.filter(
            (x: any) =>
              x.Value == val &&
              new Date(x.DatePosted) >=
              new Date(new Date(newDate).setHours(0, 0, 0, 0)) &&
              new Date(x.DatePosted) <=
              new Date(new Date(dateTo).setHours(0, 0, 0, 0))
          );
        }
        else {
          return <></>
        }
    }
  }

  useEffect(() => {
    getBetaValues();
  }, [breakDownPeriod, selectedDate]);

  function AddSuffix(num: number) {
    var n = num.toString();
    if (n.endsWith("11")) return num + "th";
    if (n.endsWith("12")) return num + "th";
    if (n.endsWith("13")) return num + "th";
    if (n.endsWith("1")) return num + "st";
    if (n.endsWith("2")) return num + "nd";
    if (n.endsWith("3")) return num + "rd";
    return num + "th";
  }

  function HandleAccordian(x: any) {
    if (document.getElementById(x)!.style.display === "block") {
      document.getElementById(x)!.style.display = "none";
    } else if (document.getElementById(x)!.style.display === "none") {
      document.getElementById(x)!.style.display = "block";
    } else {
      document.getElementById(x)!.style.display = "none";
    }
  }


  function PopulateBreakDown(idx: number) {
    var returnArray: any = [];
    for (var j = 0; j < vals.length; j++) {
      var rowData = GetRowData(breakDownData, vals[j], idx);
      var owned;
      var earned;
      var chatter;
      if (rowData.length > 0) {
        owned = rowData.filter((x: any) => x.BrandAssociationId === 1);
        earned = rowData.filter((x: any) => x.BrandAssociationId === 2);
        chatter = rowData.filter(
          (x: any) => x.BrandAssociationId === 0 || x.BrandAssociationId === 3
        );
      }
      returnArray.push(
        <tr>

          <td className="td-left">{vals[j]}</td>
          {/* <td>{owned.length === 0 ? "-" : owned.length}</td>
          <td>{earned.length === 0 ? "-" : earned.length}</td>
          <td>{chatter.length === 0 ? "-" : chatter.length}</td>
          <td>{rowData.length}</td> */}
        </tr>
      );
    }
    return returnArray;
  }

  return (
    <div id="BreakdownWidget">
      <p className="section-heading"> Breakdown - {rail} </p>
      <div id="breakdown-container" className="breakdown-widget-container">
        {alphaValue.map((x, idx: number) => (
          <div className="deep-dive-widget">
            <div className="head">
              <button
                className="accordion widget-value"
                onClick={() => HandleAccordian("0" + idx)}
              >
                {x} {betaValue[idx]}
              </button>
              <i
                className="fas fa-angle-down collapse-icon"
                onClick={() => HandleAccordian("0" + idx)}
              ></i>
            </div>

            <div className="panel" id={"0" + idx}>
              <div className="body">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th className="text-center">Owned</th>
                      <th className="text-center">Earned</th>
                      <th className="text-center">Chatter</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>{PopulateBreakDown(idx)}</tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Handles;
